import api from "@/services/api.ts";

const URL = "/deadline-extensions";

export type EffectiveDeadlines = {
  preferenceSubmission: string | null;
  mentorSelection: string | null;
};

export const getEffectiveDeadlines = async (): Promise<EffectiveDeadlines> => {
  const response = await api.get<EffectiveDeadlines>(`${URL}/effective`);
  return response.data;
};

export type DeadlineExtension = {
  id: number;
  userId: number;
  deadlineType: "preference_submission" | "mentor_selection";
  extendedUntil: string;
  reason: string | null;
  createdAt: string;
  user: { id: number; firstName: string; lastName: string; email: string };
};

export const listDeadlineExtensions = async (
  userId?: number
): Promise<DeadlineExtension[]> => {
  const params = userId != null ? { userId } : {};
  const response = await api.get<DeadlineExtension[]>(URL, { params });
  return response.data;
};

export type CreateDeadlineExtensionDto = {
  userId: number;
  deadlineType: "preference_submission" | "mentor_selection";
  extendedUntil: string; // ISO date or date-time
  reason?: string | null;
};

export const createDeadlineExtension = async (
  dto: CreateDeadlineExtensionDto
): Promise<DeadlineExtension> => {
  const response = await api.post<DeadlineExtension>(URL, dto);
  return response.data;
};

export const removeDeadlineExtension = async (id: number): Promise<void> => {
  await api.delete(`${URL}/${id}`);
};
